module.exports = __webpack_public_path__ + "img/product1.56008680.png";